import type { UikitVersionsList } from '../UikitContext';

type GetSelectedUikitVersionOptions = {
    versionsList: UikitVersionsList;
    documentationVersion: string;
    isDevelopment: boolean;
};

export const getSelectedUikitVersion = (options: GetSelectedUikitVersionOptions) => {
    const { versionsList, documentationVersion, isDevelopment } = options;

    if (isDevelopment) {
        return documentationVersion;
    }

    const selectedVersion = documentationVersion.includes('-')
        ? versionsList.versions.find(version => version.path === 'latest/')
        : versionsList.versions.find(version => version.id === documentationVersion);

    return selectedVersion?.id ?? versionsList.latest_release;
};
